import { useMemo } from "react";
import { useParams } from "react-router";
import { EditableCard } from "../../../components/editableCard.component";
import { AppRouteApi, AppRouteUi } from "../../../config/appRoute";
import { CaregiverList } from "../../caregiver/caregiverList.component";
import { ActionsCaregiverTable, useAppSelector } from "../../../core/redux";
import {
  IPaginationSearchFilter,
  useTablePaginationSearchFilter,
} from "../../../hooks/";
import { ApiSchemaFilteredCaregiver } from "../../../models/api";

export const CompanyCaregiverList = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const { pageNumber, pageSize, nextPageToken, isLoading } = useAppSelector(
    (state) => state.caregiverTable
  );
  const apiParams = useMemo<IPaginationSearchFilter["customParams"]>(() => {
    return {
      PageNumber: pageNumber,
      PageSize: pageSize,
      NextPageToken: nextPageToken,
      CompanyId: companyId,
    };
  }, [pageNumber, pageSize, nextPageToken, companyId]);
  const { apiData } = useTablePaginationSearchFilter<
    ApiSchemaFilteredCaregiver,
    typeof ActionsCaregiverTable
  >(ActionsCaregiverTable, {
    customParams: apiParams,
    apiRoute: AppRouteApi.Caregiver.Root(),
  });

  return (
    <EditableCard
      link={`${AppRouteUi.Company.Root()}/update/${companyId}`}
      title="Caregiver List"
      isValidating={isLoading}
    >
      <CaregiverList
        data={apiData?.list}
        totalCount={apiData?.totalCount}
        isValidating={isLoading}
        isInProfile
      />
    </EditableCard>
  );
};
